import { useContext } from 'react';
import { ThemeInfoContext } from 'shared/lib/mui/theme-info-context';
import { ThemeModes } from 'shared/types/theme-modes';

export const useThemeMode = (): [
  themeMode: ThemeModes,
  setThemeMode: (themeMode: ThemeModes) => void,
  resetThemeMode: () => void,
] => {
  const { themeMode, setThemeMode, resetThemeMode } =
    useContext(ThemeInfoContext);

  return [themeMode, setThemeMode, resetThemeMode];
};
